<template>
  <div v-if="ordreTravail" class="columns is-marginless is-multiline">
    <div class="entete border-entete column is-12 ">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless is-multiline">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('modificationOrdreTravailAffichage.ajouterFaceOT.title',
                  { week: week}) }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button" @click="$router.go(-1)">
                {{ $t('general.button.return')}}
              </button>
              <button class="button  is-addOrEdit "
                @click="ajouter">
                {{ $t('modificationOrdreTravailAffichage.ajouterFaceOT.ajouter')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <info-ot-consultation :ordreTravail="ordreTravail" class="column is-8">
    </info-ot-consultation>
    <info-ot-annonceur :annonceur="annonceur" class="column is-4">
    </info-ot-annonceur>

    <error-msg-component :messages="error" class="column is-12"
      :error="error.length > 0"
      :title="'general.problemOccurred'"
      :withEmplyFields="true"
      @close="error = []"/>
    <div class="mgt-20px column is-12 overflow-x-hidden" v-if="this.week">
      <tab-tournee-face-semaine :ref="referenceTable"
                                :referenceTable="referenceTable"
                                :filtres="filtres"
                                :actions="actions"
                                ligneCommandeId=""
                                :afficherDate="true"
                                :mustDisplayOnlyDispoTfs="true"
                                :afficherBoutonAffecter="false"
                                :afficherBoutonDesaffecter="false"
                                :anneeSemaine="this.week"
                                :remplacementOT=false
                                :ajouterFaceOt=true>
      </tab-tournee-face-semaine>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { INDEX_REGROUPEMENT_MANUEL } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import breadcrumb from '@/components/general/breadcrumb';
import infoOtConsultation from '@/components/logistique/ordreTravail/affichage/InfoOtConsultation';
import infoOtAnnonceur from '@/components/logistique/ordreTravail/affichage/InfoOtAnnonceur';
import tabTourneeFaceSemaine from '@/components/logistique/affectation/tabTourneeFaceSemaine';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import * as types from '@/store/modules/logistique/ordreTravailAffichage-mutation-type';
import genererLigneFaceAjouterOt from '@/services/logistique/ordreTravail/affichage/genererLigneFaceAjouterOt';
import {
  ACTION_LOGISTIQUE_MANUEL,
} from '@/configuration/logistique/tfs/tourneeFaceSemaineConf';
import { REFERENCE_TABLE_AJOUT_FACE_OT } from '@/configuration/general/referenceTableConf';

const TourneeFaceSemaine = createNamespacedHelpers('tourneeFaceSemaine');
const Ot = createNamespacedHelpers('ordreTravailAff');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'l_ajouterFaceOT',
  data() {
    return {
      filtres: {
        estAffecte: true,
      },
      actions: null,
      week: null,
      facesSelected: [],
      error: [],
      referenceTable: REFERENCE_TABLE_AJOUT_FACE_OT,
    };
  },
  components: {
    breadcrumb,
    tabTourneeFaceSemaine,
    infoOtConsultation,
    errorMsgComponent,
    infoOtAnnonceur,
  },
  computed: {
    ...TourneeFaceSemaine.mapGetters({
      critereRecherche: 'critereRecherche',
    }),
    ...Ot.mapGetters({
      ordreTravail: 'ordreTravailAffichageCourant',
      annonceur: 'otAnnonceur',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('modificationOrdreTravailAffichage.ajouterFaceOT.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('modificationOrdreTravailAffichage.ajouterFaceOT.breadcrumb.ordreTravail'), route: { name: 'l.logistique.ordre_travail-affichage' }, isActive: false },
        { title: this.$i18n.t('modificationOrdreTravailAffichage.ajouterFaceOT.breadcrumb.modificationOrdreTravailAffichage'), route: { name: 'm.logistique.ordre_travail-affichage', params: { id: this.ordreTravail.id } }, isActive: false },
        { title: this.$i18n.t('modificationOrdreTravailAffichage.ajouterFaceOT.breadcrumb.title'), route: '', isActive: true },
      ];
    },
  },
  methods: {
    ...Ot.mapMutations({
      setOtCourant: types.SET_OT_COURANT,
    }),
    ajouter() {
      if (!this.$refs[this.referenceTable].getAllTourneeFaceSemaineSelected.length) {
        this.error.push({ message: 'modificationOrdreTravailAffichage.ajouterFaceOT.noSelection' });
        return;
      }
      this.facesSelected = this.$refs[this.referenceTable]
        .getAllTourneeFaceSemaineSelected;
      if (!this.facesSelected) return;

      this.facesSelected.forEach((face) => {
        const faceExistante = this.ordreTravail.faces.find(f => f.produitId === face.produitId);
        if (faceExistante != null) {
          this.error.push({
            message: 'modificationOrdreTravailAffichage.ajouterFaceOT.alreadyExist',
            parametres: { faceReference: face.produitReference },
          });
          return;
        }
        let ligneOt = null;
        if (this.annonceur.devisCommandeId !== null) {
          ligneOt = this.ordreTravail.faces.find(f => {
            return f.id !== face.id
              && f.affectationLogistiqueCommandeId === this.annonceur.devisCommandeId;
          });
        } else if (this.annonceur.indexRegroupement !== INDEX_REGROUPEMENT_MANUEL) {
          ligneOt = this.ordreTravail.faces.find(f => {
            return f.id !== face.id && f.indexRegroupement === this.annonceur.indexRegroupement;
          });
        }
        if (ligneOt != null) {
          this.annonceur.affectationLogistiqueCommandeId = ligneOt
            .affectationLogistiqueCommandeId;
          this.annonceur.affectationLogistiqueLigneCommandeId = ligneOt
            .affectationLogistiqueLigneCommandeId;
          this.annonceur.affectationLogistiqueProduitId = ligneOt.affectationLogistiqueProduitId;
          this.annonceur.actionLogistique = ligneOt.actionLogistique;
          this.annonceur.indexRegroupement = ligneOt.indexRegroupement;
        } else {
          this.annonceur.affectationLogistiqueCommandeId = null;
          this.annonceur.affectationLogistiqueLigneCommandeId = null;
          this.annonceur.affectationLogistiqueProduitId = null;
          this.annonceur.actionLogistique = ACTION_LOGISTIQUE_MANUEL;
        }
        this.ordreTravail.faces.push(genererLigneFaceAjouterOt(
          face,
          this.societeActive,
          this.annonceur,
        ));
      });
      if (this.error.length > 0) return;
      this.setOtCourant(this.ordreTravail);
      this.$router.go(-1);
    },
  },
  mounted() {
    if (!this.ordreTravail) {
      this.$router.go(-1);
    }
    this.critereRecherche.avecLaisserEnPlaceVente = null;
    this.critereRecherche.afficheurIds = [];
    this.critereRecherche.sansAfficheur = null;
    this.filtres.notInOtId = this.ordreTravail.id;
    this.week = parseInt(getAnneeSemaineFromDate(this.ordreTravail.dateDepart), 10);
    this.setInformationPage(this.$t('pageLogistique.ot.remplacementFaceOtAff'));
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'm.logistique.ordre_travail-affichage') {
      this.setOtCourant(null);
    }
    next();
  },
};
</script>
